/**
 * CareStart Studio — query IDs whose P1 overrides the orchestrator honors (Phase 3).
 *
 * WHAT: Fixed allowlist for the per-variant prompt editor (voice prompts omitted — separate path).
 * WHY: Supervisors edit only prompts that take effect at runtime via variantSlug + orchestrator.
 * INVARIANT: Must stay aligned with orchestrator override keys and getCareStartPromptsForSupervisor.
 */

export const CARESTART_EDITABLE_PROMPT_QUERIES = Object.freeze([
  {
    queryId: 'symptom-checker-v2-ddx-standalone-scmap4',
    label: 'Diagnosis analysis',
  },
  {
    queryId: 'symptom-checker-v2-ddx-standalone-phase3-scmap4',
    label: 'Detailed diagnosis',
  },
  {
    queryId: 'symptom-checker-v2-triage-scmap4',
    label: 'Care level decision',
  },
  {
    queryId: 'chartmind-diagnostic-tests-scmap4',
    label: 'Suggested tests',
  },
]);

/** @type {Set<string>} */
export const CARESTART_EDITABLE_PROMPT_QUERY_IDS = new Set(
  CARESTART_EDITABLE_PROMPT_QUERIES.map((q) => q.queryId)
);

const careStartEditablePrompts = {
  CARESTART_EDITABLE_PROMPT_QUERIES,
  CARESTART_EDITABLE_PROMPT_QUERY_IDS,
};

export default careStartEditablePrompts;
